module.exports = __webpack_public_path__ + "img/wb1t1.8ec5ffd6.png";